import React, { FC } from 'react';
import styled from 'styled-components';
import { WindowWidthContext } from '@minecraft.utils';
import { DrawerProps } from '../shared/types';
import { useDrawerToggleCategory } from '../shared/hooks';
import DrawerNavigation from '../DrawerNavigation';
import DrawerCategoryView from '../DrawerCategoryView';

const DrawerBodyContent = styled.div`
  display: flex;
  flex: 1 0 auto;
  height: calc(100vh - 6.5rem);
`;

interface Props {
  submitClick: DrawerProps['submitClick'];
  renderAdditionalNavigationControls: DrawerProps['renderAdditionalNavigationControls'];
  children: DrawerProps['children'];
}

const DrawerBody: FC<Props> = ({ submitClick, renderAdditionalNavigationControls, children }) => {
  const { lessSm } = WindowWidthContext.useWidthData();

  const { activeCategory } = useDrawerToggleCategory();

  const isDrawerNavigationVisible = (lessSm && !activeCategory.value) || !lessSm;
  const isDrawerCategoryViewVisible = (lessSm && activeCategory.value) || !lessSm;

  return (
    <DrawerBodyContent>
      {isDrawerNavigationVisible && (
        <DrawerNavigation
          submitClick={submitClick}
          renderAdditionalNavigationControls={renderAdditionalNavigationControls}
        />
      )}
      {isDrawerCategoryViewVisible && <DrawerCategoryView>{children}</DrawerCategoryView>}
    </DrawerBodyContent>
  );
};

export default DrawerBody;
